export const COST_INPUT_CONFIG = {
  controlName: 'Cost',
  placeholder: 'Оголошена цінність',
  maxValue: 5000000,
  minValue: 0.1,
  allowFloat: true,
  digitsAfterDot: 2,
  maxInputLength: 7,
  initialValue: 200,
  unit: 'грн',
  debounceTime: 1500,
  tooltipText:
    'Загальна оголошена вартість розраховується автоматично як сума оголошених вартостей усіх місць. Відшкодування здійснюється відповідно до оголошеної вартості, зазначеної для цього місця.',
};

export const TIRE_WHEEL_COST_INPUT_CONFIG = {
  controlName: 'cost',
  placeholder: 'Оголошена цінність',
  maxValue: COST_INPUT_CONFIG.maxValue,
  minValue: COST_INPUT_CONFIG.minValue,
  allowFloat: COST_INPUT_CONFIG.allowFloat,
  digitsAfterDot: COST_INPUT_CONFIG.digitsAfterDot,
  maxInputLength: COST_INPUT_CONFIG.maxInputLength,
  unit: COST_INPUT_CONFIG.unit,
  tooltipText:
    'Оголошена цінність вказується окремо для кожного місця. Загальна сума розраховується автоматично.',
};
